module.exports = __webpack_public_path__ + "img/Perdues@1x.41292235.png";